import React from "react";
import "./index.scss";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { Button } from "antd";
function BriefIntroduction() {
  const { t } = useTranslation();
  const history = useHistory();
  const briefIntroductionContent = t("aboutUs.space_part2", {
    returnObjects: true,
  });
  const clickTo = () => {
    history.push(`/apply`);
  };
  return (
    <div className="brief_">
      <div className="brief_con">
        <div className="brief_con_left">
          <div className="brief_con_l_title">{briefIntroductionContent.title}</div>
          <div className="brief_con_l_list">
            {briefIntroductionContent.list.map((item, index) => {
              return (
                <div className="brief_con_l_li" key={index}>
                  <div className="brief_con_l_li_img">
                    <img src={item.iconUrl} alt="" />
                  </div>
                  <div className="brief_con_l_li_text">
                    <div className="brief_con_l_li_til">{item.itemTitle}</div>
                    <div className="brief_con_l_li_con">{item.itemContent}</div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div className="brief_con_right">
          <img src={briefIntroductionContent.imgUrl} alt="" />
          <div className="brief_con_r_text">
            <div className="brief_con_r_textTitle">{briefIntroductionContent.describeTitle}</div>
            <p className="brief_con_r_textContent">{briefIntroductionContent.describeContent}</p>
            {/* <Button className="brief_con_r_textBtn"  onClick={() => clickTo()}>{briefIntroductionContent.learnMore}{'->'}</Button> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default BriefIntroduction;
